// src/pages/WishlistPage.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { useAuth } from '../context/AuthContext';
import { getProduct } from '../firebase/services';

export default function WishlistPage() {
  const { user, userData, refreshUserData } = useAuth();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { navigate('/login'); return; }
    const ids = userData?.wishlist || [];
    if (!ids.length) { setLoading(false); return; }
    Promise.all(ids.map(id => getProduct(id)))
      .then(prods => setProducts(prods.filter(Boolean)))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [user, userData?.wishlist, navigate]);

  return (
    <div style={{ paddingTop: 68, minHeight: '80vh' }}>
      {/* Header */}
      <div style={{ background: 'var(--bg-2)', borderBottom: '1px solid var(--border)', padding: '44px 40px 32px' }}>
        <div className="container" style={{ padding: 0 }}>
          <p className="section-eyebrow">Saved</p>
          <h1 className="section-title">My Wishlist</h1>
          {products.length > 0 && (
            <p style={{ color: 'var(--text-3)', fontSize: 13, marginTop: 8 }}>
              {products.length} saved item{products.length !== 1 ? 's' : ''}
            </p>
          )}
        </div>
      </div>

      <div className="container" style={{ padding: '44px 40px' }}>
        {loading ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 20 }}>
            {[...Array(4)].map((_, i) => (
              <div key={i}>
                <div className="skeleton" style={{ paddingTop: '100%', borderRadius: 8, marginBottom: 12 }} />
                <div className="skeleton" style={{ height: 16, width: '65%', marginBottom: 8 }} />
                <div className="skeleton" style={{ height: 12, width: '40%' }} />
              </div>
            ))}
          </div>
        ) : products.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '100px 0' }}>
            <div style={{ fontSize: 64, marginBottom: 20 }}>♡</div>
            <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: 28, fontWeight: 400, marginBottom: 12 }}>
              Your wishlist is empty
            </h3>
            <p style={{ color: 'var(--text-3)', maxWidth: 380, margin: '0 auto 28px' }}>
              Save food items and luxury products you love by tapping the heart icon.
            </p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <Link to="/shop?type=food" className="btn btn-emerald">Browse Food</Link>
              <Link to="/shop?type=shopping" className="btn btn-gold">Browse Shop</Link>
            </div>
          </div>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 20 }}>
              {products.map((p, i) => (
                <ProductCard
                  key={p.id}
                  product={p}
                  wishlistIds={userData?.wishlist || []}
                  onWishlistChange={refreshUserData}
                  animDelay={i * 0.07}
                />
              ))}
            </div>

            {/* Move all to cart suggestion */}
            <div style={{ marginTop: 52, padding: '28px 32px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 20 }}>
              <div>
                <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, marginBottom: 4 }}>Ready to order?</div>
                <div style={{ fontSize: 13, color: 'var(--text-3)' }}>Browse your saved items and add them to your cart.</div>
              </div>
              <div style={{ display: 'flex', gap: 12 }}>
                <Link to="/shop" className="btn btn-outline btn-sm">Continue Browsing</Link>
                <Link to="/cart" className="btn btn-gold btn-sm">View Cart</Link>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
